// images
import logo from "../../icons/logo.png";
import phone from "../../icons/phone.png";
import en from "../../icons/global.svg";
import ar from "../../icons/sa.svg";
import React from 'react';
// Imports
import { Button, Divider, Stack, Typography } from "@mui/material";
import "./Navbar.scss";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { HashLink as Hash } from "react-router-hash-link";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";

const Navbar = () => {
    const navigate = useNavigate();
    const [active, setactive] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("lang")) {
            if (localStorage.getItem("lang") === "ar") {
                document.body.classList.add("ar");
            } else {
                document.body.classList.remove("ar");
            }
        } else {
            localStorage.setItem("lang", "en");
        }
    }, []);

    const handleChange = (e) => {
        if (localStorage.getItem("lang") === "en") {
            localStorage.setItem("lang", "ar");
            window.location.reload();
        } else {
            localStorage.setItem("lang", "en");
            window.location.reload();
        }
    };

    if (localStorage.getItem("lang") === "en") {
        return (
            <div id="nav-bar" className="Navbar">
                <div className="container">
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="flex-end"
                        spacing={4}
                        sx={{
                            width: "fit-content",
                            position: "absolute",
                            top: "-2px",
                            right: "0",
                            px: 10,
                            pt: 4,
                            pb: 3,
                            border: "1px solid",
                            borderColor: "text.primary",
                            borderBottomLeftRadius: "15px",
                            borderBottomRightRadius: "15px",
                            display: { xs: "none", md: "flex" },
                        }}
                    >
                        <img src={phone} alt="" />

                        <Typography variant="span" color="text.secondary">
                            +966 534 470 076
                        </Typography>

                        <Typography
                            onClick={(e) => handleChange(e)}
                            sx={{
                                fontSize: "15px",
                                color: "primary.main",
                                lineHeight: "10px",
                                pl: 4,
                                py: 2,
                                borderLeft: "1px solid",
                                cursor: "pointer",
                                "&:hover": {
                                    color: "secondary.main",
                                },
                            }}
                        >
                            AR  <img width="20" style={{ margin: "0 2px" }} src={ar} alt="" />


                        </Typography>
                    </Stack>

                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                            pt: { xs: 10, md: 20 },
                            pb: 10,
                        }}
                    >
                        <div className="logo">
                            <Link to="/">
                                <img src={logo} alt="" />
                            </Link>
                        </div>

                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={8}
                            divider={
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{
                                        bgcolor: "secondary.main",
                                    }}
                                />
                            }
                            sx={{
                                fontSize: "18px",
                                display: { xs: "none", md: "flex" },
                            }}
                            className="list"
                        >
                            <NavLink to="/">Overview</NavLink>
                            <Hash to="/#features">Features</Hash>
                            <NavLink to="/application">App</NavLink>
                            <NavLink to="/caseStudy">Case Studies</NavLink>
                            <NavLink to="/media">Media & News Center</NavLink>
                        </Stack>

                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={12}
                            className="login-demo"
                            sx={{
                                display: { xs: "none", md: "flex" },
                            }}
                        >
                            <NavLink to="/login">Login</NavLink>
                            <Button
                                onClick={() => navigate("/demo")}
                                variant="contained"
                                sx={{
                                    borderRadius: "12px",
                                    py: 5,
                                    px: 14,
                                    fontSize: "18px",
                                    lineHeight: "22px",
                                    "&:hover": { color: "secondary.main" },
                                }}
                            >
                                <NavLink to="/demo">Book a demo</NavLink>
                            </Button>
                        </Stack>

                        {active ? (
                            <CloseIcon
                                fontSize="large"
                                color="primary"
                                sx={{
                                    cursor: "pointer",
                                    display: { xs: "block", md: "none" },
                                    "&:hover": {
                                        color: "secondary.main",
                                    },
                                }}
                                onClick={() => setactive(false)}
                            />
                        ) : (
                            <MenuIcon
                                fontSize="large"
                                color="primary"
                                sx={{
                                    cursor: "pointer",
                                    display: { xs: "block", md: "none" },
                                    "&:hover": {
                                        color: "secondary.main",
                                    },
                                }}
                                onClick={() => setactive(true)}
                            />
                        )}
                    </Stack>

                    {active && <Menu setactive={setactive} />}
                </div>
            </div>
        );
    } else {
        return (
            <div className="Navbar">
                <div className="container">
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="flex-end"
                        spacing={4}
                        sx={{
                            width: "fit-content",
                            position: "absolute",
                            top: "-2px",
                            right: "0",
                            px: 10,
                            pt: 4,
                            pb: 3,
                            border: "1px solid",
                            borderColor: "text.primary",
                            borderBottomLeftRadius: "15px",
                            borderBottomRightRadius: "15px",
                            display: { xs: "none", md: "flex" },
                        }}
                    >
                        <img src={phone} alt="" />



                        {localStorage.getItem("lang") === "en" ? (
                            <Typography variant="span" color="text.secondary" className="s1">
                                +966 534 470 076
                            </Typography>
                        ) : (
                            <Typography variant="span" sx={{ fontSize: "14px" }} color="text.secondary" className="s1">
                                +966 534 470 076
                            </Typography>
                        )}

                        <Typography
                            onClick={(e) => handleChange(e)}
                            sx={{
                                fontSize: "15px",
                                color: "primary.main",
                                lineHeight: "10px",
                                pl: 4,
                                py: 2,
                                borderLeft: "1px solid",
                                cursor: "pointer",
                                "&:hover": {
                                    color: "secondary.main",
                                },
                            }}
                        >
                            EN    <img width="20" style={{ margin: "0 2px" }} src={en} alt="" />
                        </Typography>
                    </Stack>

                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                            pt: { xs: 10, md: 20 },
                            pb: 10,
                        }}
                    >
                        <div className="logo">
                            <Link to="/">
                                <img src={logo} alt="" />
                            </Link>
                        </div>

                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={8}
                            divider={
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{
                                        bgcolor: "secondary.main",
                                    }}
                                />
                            }
                            sx={{
                                fontSize: "18px",
                                display: { xs: "none", md: "flex" },
                            }}
                            className="list"
                        >
                            <NavLink to="/">الرئيسية</NavLink>
                            <Hash to="/#features">الميزات</Hash>
                            <NavLink to="/application">التطبيق</NavLink>
                            <NavLink to="/caseStudy">الدراسات</NavLink>
                            <NavLink to="/media">الاعلام والأخبار</NavLink>
                        </Stack>

                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={12}
                            className="login-demo"
                            sx={{
                                display: { xs: "none", md: "flex" },
                            }}
                        >
                            <NavLink to="/login">تسجيل دخول</NavLink>
                            <Button
                                onClick={() => navigate("/demo")}
                                variant="contained"
                                sx={{
                                    borderRadius: "12px",
                                    py: 5,
                                    px: 14,
                                    fontSize: "18px",
                                    lineHeight: "22px",
                                    "&:hover": { color: "secondary.main" },
                                }}
                            >
                                <NavLink to="/demo">احجز عرض</NavLink>
                            </Button>
                        </Stack>

                        {active ? (
                            <CloseIcon
                                fontSize="large"
                                color="primary"
                                sx={{
                                    cursor: "pointer",
                                    display: { xs: "block", md: "none" },
                                    "&:hover": {
                                        color: "secondary.main",
                                    },
                                }}
                                onClick={() => setactive(false)}
                            />
                        ) : (
                            <MenuIcon
                                fontSize="large"
                                color="primary"
                                sx={{
                                    cursor: "pointer",
                                    display: { xs: "block", md: "none" },
                                    "&:hover": {
                                        color: "secondary.main",
                                    },
                                }}
                                onClick={() => setactive(true)}
                            />
                        )}
                    </Stack>

                    {active && <Menu setactive={setactive} />}
                </div>
            </div>
        );
    }
};

const Menu = ({ setactive }) => {

    const handleChange = (e) => {
        e.preventDefault()

        if (localStorage.getItem("lang") === "en") {
            localStorage.setItem("lang", "ar");
            window.location.reload();
        } else {
            localStorage.setItem("lang", "en");
            window.location.reload();
        }
    };


    if (localStorage.getItem("lang") === "en") {
        return (
            <div className="Menu">
                <Stack
                    sx={{
                        position: "fixed",
                        zIndex: "10000000",
                        top: "0",
                        left: "0",
                        bgcolor: "white",
                        height: "100vh",
                        width: "70%",
                        py: 20,
                        px: 10,
                        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                    }}
                >
                    <Stack onClick={() => setactive(false)}>
                        <div className="logo">
                            <Link to="/">
                                <img src={logo} alt="" />
                            </Link>
                        </div>
                        <NavLink to="/">Overview</NavLink>
                        <Hash to="/#features">Features</Hash>
                        <NavLink to="/application">App</NavLink>
                        <NavLink to="/caseStudy">Case Studies</NavLink>
                        <NavLink to="/media">Media & News Center</NavLink>
                        <NavLink to="/login">Login</NavLink>
                        <NavLink to="/sign-up">Register</NavLink>
                        <NavLink to="/demo">Book a demo</NavLink>
                        <Link onClick={(e) => handleChange(e)}>العربية</Link>
                    </Stack>
                </Stack>
            </div>
        );
    } else {
        return (
            <div className="Menu">
                <Stack
                    sx={{
                        position: "fixed",
                        zIndex: "10000000",
                        top: "0",
                        left: "0",
                        bgcolor: "white",
                        height: "100vh",
                        width: "70%",
                        py: 20,
                        px: 10,
                        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                    }}
                >
                    <Stack onClick={() => setactive(false)}>
                        <div className="logo">
                            <Link to="/">
                                <img src={logo} alt="" />
                            </Link>
                        </div>
                        <NavLink to="/">الرئيسية</NavLink>
                        <Hash to="/#features">الميزات</Hash>
                        <NavLink to="/application">التطبيق</NavLink>
                        <NavLink to="/caseStudy">الدراسات</NavLink>
                        <NavLink to="/media">الاعلام والأخبار</NavLink>
                        <NavLink to="/login">تسجيل</NavLink>
                        <NavLink to="/sign-up">حساب جديد</NavLink>
                        <NavLink to="/demo">احجز عرض توضيحي</NavLink>
                        <Link onClick={(e) => handleChange(e)}>English</Link>
                    </Stack>
                </Stack>
            </div>
        );
    }
};

export default Navbar;
